export default "__VITE_ASSET__CpGCvnw5__"